import {
	lazy,
} from 'react'

export const RoomsPageAsync = lazy(async() => {
	return import('./rooms.page')
})
